import { useCampaignSetting } from '@campaign-services/hooks/use-campaign-setting'
import { type CountryCode, type ProjectCode } from '@constants'
import { useFastpassCampaignGoogleAnalyticEvent } from '@dni-analysis'
import { useDialog } from '@dni-hooks/useDialog'
import { useApiCampaignMember } from '@hooks-api/fortune/useApiCampaignMember'
import { Button } from '@pets-ui/Button/Button'
import { Footer, type FooterProps } from '@pets-ui/Footer/Footer'
import { HStack } from '@pets-ui/HStack/HStack'
import { ArrowRightSmall, Coupon } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useHistory } from 'react-router-dom-v5'
import { DIALOG_COUPON, DialogCoupon } from '../DialogCoupon/DialogCoupon'

const styles = stylex.create({
  button: {
    borderColor: colors.grey300,
    justifyContent: 'flex-start',
    width: '100%',
  },
  footer: {
    alignItems: 'center',
    display: 'flex',
    height: 56,
  },
})
export interface FooterCouponProps extends FooterProps {
  campaignId: number
  campaignCode?: string
  currency?: string
  projectCode: ProjectCode
  countryCode: CountryCode
}

const LoggedInAction = (props: FooterCouponProps) => {
  const { campaignCode, campaignId, projectCode, currency, countryCode } = props
  const { openDialog: openDialogCoupon } = useDialog(DIALOG_COUPON)
  const { sendClickCouponEvent } = useFastpassCampaignGoogleAnalyticEvent({ projectCode, countryCode, campaignId })

  const handleActionClick = () => {
    sendClickCouponEvent()
    openDialogCoupon({
      projectCode,
      countryCode,
      currency,
      campaignId,
      campaignCode,
    })
  }

  return (
    <Button
      fullWidth
      variant="text"
      color="blue"
      rootStyle={[styles.button]}
      onClick={handleActionClick}
    >
      <Text variant="body" color={colors.blue600}>查看或使用優惠</Text>
    </Button>
  )
}

const NotLoggedInAction = (props: Pick<FooterCouponProps, 'campaignCode'>) => {
  const { campaignCode } = props
  const history = useHistory()
  const handleLogin = () => {
    history.push(`/campaigns/${campaignCode}/login`, {
      referrer: window.location.href,
    })
  }
  return (
    <HStack gap={2}>
      <Text>登入享優惠</Text>
      <Button variant="text" color="blue" onClick={handleLogin}>
        立刻登入
        <ArrowRightSmall />
      </Button>
    </HStack>
  )
}
export const FooterCoupon = (props: FooterCouponProps) => {
  const { campaignCode } = props
  const { isMemberLoginTypeGuest } = useCampaignSetting()
  const { destructuredData: campaignMember } = useApiCampaignMember({ code: campaignCode })
  const isLoggedIn = !!campaignMember
  return (
    <div className="footer-coupon">
      <DialogCoupon />
      <Footer rootStyle={[styles.footer]}>
        <HStack justifyContent="space-between" alignItems="center" width="100%">
          <HStack gap={2}>
            <VStack justifyContent="center">
              <Coupon />
            </VStack>
            <Text>優惠折扣</Text>
          </HStack>
          <HStack justifyContent="flex-end">
            {(isLoggedIn || isMemberLoginTypeGuest) ? <LoggedInAction {...props} /> : <NotLoggedInAction campaignCode={campaignCode} />}
          </HStack>
        </HStack>
      </Footer>
    </div>
  )
}
